// src/components/Admin2/Sidebar.jsx
import React, { useEffect, useState } from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import '../components/sidebar.css';
import safrelog from '../safreeimg/safreelogo.png';
import hdrman from '../safreeimg/man.png';
import dashbo from '../safreeimg/superadminimg/dash.png';
import user from '../safreeimg/superadminimg/user.png';
import Organisation from '../safreeimg/superadminimg/orgtion.png';
import Alarm from '../safreeimg/superadminimg/alrm.png';
import manual from '../safreeimg/superadminimg/manualnoti.png';
import logout from '../safreeimg/superadminimg/logout.png';
import { onMessageListener } from '../components/firebase.messaging';
import loonotifi from '../safreeimg/safreelogo.png';
import address from '../safreeimg/Group131.png'
import location from '../safreeimg/Group132.png'
// pageslink.. 
import Admin2Page1 from '../components/Admin2/Pages/Page1'
import OrgUserManagement from './Admin2/Pages/orgUserManagement';
import OrgUserGuardians from './Admin2/Pages/orgUserGuardians';
import OrgUserisGuardians from './Admin2/Pages/orgUserisGuarding';
import OrgGroupManagement from './Admin2/Pages/orgGroupManagement';
import OrgGroupViewDetail from './Admin2/Pages/orgGroupViewDetail';
import OrgSubGroupViewDetails from './Admin2/Pages/orgSubGroupDetails';
import OrgSubGroupsViewDetails from './Admin2/Pages/orgSubGroupViewDetails';
import OrgAddNewGroup from './Admin2/Pages/orgAddNewGroup'
import OrgAddNewSubGroup from './Admin2/Pages/orgAddNewSubGroup'
import OrgAlarmManagement from './Admin2/Pages/orgAlarmManagement';
import OrgManualNotification from './Admin2/Pages/orgManualNotification';
import OrgUserAlarms from './Admin2/Pages/orgUserAlarms';
import OrgUserMap from './Admin2/Pages/orgUserMap';
import AddNewMember from './Admin2/Pages/orgAddNewMember';
import AddNewSubMember from './Admin2/Pages/orgAddNewSubMember';
import Notifications from './Admin2/Pages/notifications';
import ChoosePlan from './Admin2/Pages/planmanagement';
import { ToastContainer, toast } from 'react-toastify';
import NotificationAlarmManagment from './Admin2/Pages/notificationAlarmManagement';

// pageslink.. 
const Admin2Sidebar = ({ children }) => {

  const navigate = useNavigate();
  const [notificationData, setNotificationData] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [name, setName] = useState('');



  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };
  useEffect(() => {
    const fetchOrgName = async () => {
      const token = localStorage.getItem('token');

      if (!token) return;

      try {
        const response = await fetch('https://api.safree.org/api-v2022/organization/auth/v1/name', {
          method: 'GET',
          headers: {
            'Authorization': ` ${token}`,
          },
        });

        const result = await response.json();

        if (response.ok && result.success && result.data?.name) {
          setName(result.data.name);
        } else {
          console.warn('Name not found in API response');
        }

      } catch (error) {
        console.error('Error fetching organization name:', error);
      }
    };

    fetchOrgName();
  }, []);

  useEffect(() => {
    const fetchNotificationData = async () => {
      const unsubscribe = onMessageListener()
        .then((payload) => {
          console.log("🚨 Notification received: ", payload);
          const data = payload?.data || {};
          setNotificationData({
            location: data.address || "Unknown Location",
            raisedBy: data.raisedByUser || "Unknown",
            guardians: data.guardians || "Unknown",
            dateTime: new Date().toLocaleString(),
            alarmId: data.alarmId || "",
          });
          setShowNotification(true);
          toast.info("📢 S.O.S. Alarm Raised!", {
            autoClose: 10000,
          });

          setTimeout(() => {
            setShowNotification(false);
          }, 10000);
        })
        .catch((err) => console.log("❌ Notification Error:", err));

      return unsubscribe; // Clean up on unmount
    };

    // Initial fetch when component mounts
    fetchNotificationData();

    // Set up the interval to reload notification every 3 seconds
    const intervalId = setInterval(() => {
      fetchNotificationData(); // Fetch new notification every 3 seconds
    }, 3000);

    // Clean up interval when component unmounts
    return () => clearInterval(intervalId);

  }, []);

  const handleCloseNotification = () => {
    setShowNotification(false);
  };
  return (
    <div className="app-container">
      <ToastContainer />
      {/* 🔔 Firebase Notification Popup */}
      {showNotification && (
        <div style={{
          position: 'fixed',
          top: '20%',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9999,
          background: '#fff',
          padding: '24px',
          borderRadius: '20px',
          width: '400px',
          boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
          fontFamily: 'sans-serif',
        }}>
          <button onClick={handleCloseNotification} style={{
            position: 'absolute',
            top: '16px',
            right: '20px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
          }}>×</button>

          <div style={{ textAlign: 'center', marginBottom: '12px' }}>
            <img src={loonotifi} alt="Safree Logo" style={{ height: '60px' }} />
          </div>

          <h2 style={{ textAlign: 'center', fontWeight: '600', fontSize: '18px', marginBottom: '12px' }}>
            S.O.S. Alarm Raised
          </h2>

          <hr style={{ marginBottom: '0px', borderColor: '#eee' }} />
          <div style={{
            fontSize: '14px',
            marginBottom: '0px',
            marginTop: '12px',
            padding: '0px 31px',
            display: 'flex',
            gap: '12px',
            alignItems: 'center'
          }}
          >
            <span style={{ fontSize: '18px', color: '#000' }}>Alarm Raise By:</span> <span style={{ float: 'right' }}>{notificationData.raisedBy}</span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={location} alt="location" style={{ width: '23%' }} />
            <p style={{ fontSize: '12px', fontWeight: '500' }}>{notificationData.location}</p>
          </div>

          <div style={{ display: 'flex', marginTop: '-40px', alignItems: 'center' }}>
            <img src={address} alt="calendar" style={{ width: '23%' }} />
            <p style={{ fontSize: '12px', fontWeight: '500' }}>{notificationData.dateTime}</p>
          </div>


          <div style={{ fontSize: '14px', marginBottom: '20px', marginTop: '-15px', paddingLeft: '28px' }}>
            <span style={{ fontSize: '20px', color: '#000', fontWeight: 500 }}>Guardians:</span> <span>{notificationData.guardians}</span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button style={{
              backgroundColor: '#000',
              color: '#fff',
              padding: '10px 24px',
              borderRadius: '50px',
              fontWeight: '600',
              cursor: 'pointer',
              border: 'none',
              flex: 1,
              marginRight: '10px',
              width: '100%',
              marginTop: '18px'
            }}
              onClick={() => {
                setShowNotification(false);
                navigate(`/admin2/notificationAlarmManagment/#${notificationData.alarmId}`);
              }}
            >
              View Details
            </button>
          </div>
        </div>
      )}
      {/* Sidebar */}
      <aside className="sidebar">
        <ul>
          <NavLink
            to="/admin2/dashboard"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={dashbo} alt="Dashboard Icon" />
              </span>
              Dashboard
            </li>
          </NavLink>
          <NavLink
            to="/admin2/orgUserManagement"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={user} alt="User Management Icon" />
              </span>
              User Management
            </li>
          </NavLink>
          <NavLink
            to="/admin2/orgGroupManagement"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={Organisation} alt="Organisation Icon" />
              </span>
              Group Management
            </li>
          </NavLink>
          <NavLink
            to="/admin2/choosePlan"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={Organisation} alt=" Icon" />
              </span>
              Subscription Management
            </li>
          </NavLink>
          <NavLink
            to="/admin2/orgAlarmManagement"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={Alarm} alt="Alarm Management Icon" />
              </span>
              Alarm Management
            </li>
          </NavLink>
          <NavLink
            to="/admin2/orgManualNotification"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={manual} alt="Manual Notification Icon" />
              </span>
              Manual Notification
            </li>
          </NavLink>
          <NavLink
            to="/admin2/notifications"
            className={({ isActive, isPartiallyActive }) =>
              isActive || isPartiallyActive ? 'sidebar-link active' : 'sidebar-link'
            }
          >
            <li className="sidebar-item">
              <span className="icon">
                <img src={manual} alt="Notification Icon" />
              </span>
              Notifications
            </li>
          </NavLink>
          {/* Logout Button */}
          <li className="sidebar-item sidebar-items sidebar-link" onClick={handleLogout}>
            <span className="icon">
              <img src={logout} alt="Logout Icon" />
            </span>
            Logout
          </li>
        </ul>
        <ul className='sidpriv sidprivs '>
          <a href="https://safree.org/Terms&Conditions.html" target="_blank" rel="noopener noreferrer">
            Terms & Conditions
          </a>
          <a href="https://safree.org/privacy.html" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
        </ul>

      </aside>

      {/* Main Content */}
      <main className="main-content">
        <header className="app-header orghdrtext">
          <div className="logo">
            <img src={safrelog} alt="Logo" />
          </div>
          <div className='orgname'>
            <h2>{name.toUpperCase()}</h2>
          </div>
        </header>
        <div className="content">
          {children}
          <Routes>
            <Route path="dashboard" element={<Admin2Page1 />} />
            <Route path="orgUserManagement" element={<OrgUserManagement />} />
            <Route path="/orgUserManagement/orgUserGuardians" element={<OrgUserGuardians />} />
            <Route path="/orgUserManagement/orgUserisGuardians" element={<OrgUserisGuardians />} />
            <Route path="orgGroupManagement" element={<OrgGroupManagement />} />
            <Route path="/orgGroupManagement/orgGroupViewDetail" element={<OrgGroupViewDetail />} />
            <Route path="/orgGroupManagement/orgSubGroupViewDetails" element={<OrgSubGroupViewDetails />} />
            <Route path="orgSubGroupsViewDetails" element={<OrgSubGroupsViewDetails />} />
            <Route path="/orgGroupManagement/orgAddNewGroup" element={<OrgAddNewGroup />} />
            <Route path="/orgGroupManagement/orgSubGroupViewDetails/orgAddNewSubGroup" element={<OrgAddNewSubGroup />} />
            <Route path="orgAlarmManagement" element={<OrgAlarmManagement />} />
            <Route path="orgManualNotification" element={<OrgManualNotification />} />
            <Route path="/orgUserManagement/orgUserAlarms" element={<OrgUserAlarms />} />
            <Route path="orgUserMap" element={<OrgUserMap />} />
            <Route path="/orgGroupManagement/orgGroupViewDetail/addNewMember" element={<AddNewMember />} />
            <Route path="addNewSubMember" element={<AddNewSubMember />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="choosePlan" element={<ChoosePlan />} />
            <Route path="notificationAlarmManagment" element={<NotificationAlarmManagment />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default Admin2Sidebar;
